var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22,
    r: 21,
    fill: "#0C1525",
    stroke: "url(#paint0_linear_9501_68811)",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9501_68811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4999 18.6217C23.2008 18.6217 23.7691 18.0534 23.7691 17.3525C23.7691 16.6516 23.2008 16.0833 22.4999 16.0833C21.799 16.0833 21.2307 16.6516 21.2307 17.3525C21.2307 18.0534 21.799 18.6217 22.4999 18.6217Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 12.0008H15.8334C13.9803 12.0154 12.489 13.5277 12.5001 15.3808V25.5224C12.489 27.3757 13.9802 28.8881 15.8334 28.9033H18.2692L21.3925 31.5699C22.0112 32.1353 22.9565 32.1436 23.585 31.5891L26.7892 28.9024H29.1667C31.0199 28.8873 32.5111 27.3749 32.5 25.5216V15.3808C32.5112 13.5277 31.0198 12.0154 29.1667 12.0008ZM22.5001 14.5358C26.3459 14.6375 26.3451 20.35 22.5001 20.4525C18.6542 20.3499 18.6551 14.6399 22.5001 14.5358ZM26.0409 26.3408C25.5949 26.4546 25.1412 26.1853 25.0274 25.7393C25.0269 25.7373 25.0264 25.7353 25.0259 25.7333C24.5994 24.3381 23.1225 23.5528 21.7273 23.9793C20.8875 24.2361 20.2301 24.8935 19.9734 25.7333C19.8569 26.1788 19.4014 26.4456 18.9559 26.3291C18.5104 26.2127 18.2436 25.7571 18.3601 25.3116C19.0044 23.0249 21.3805 21.6936 23.6672 22.3379C25.1084 22.7441 26.2348 23.8704 26.6409 25.3116C26.7569 25.7611 26.4892 26.2202 26.0409 26.3408Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9501_68811",
    x1: 2.5,
    y1: 64.5926,
    x2: 50.4216,
    y2: 59.8518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.150307,
    stopColor: "#44A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336372,
    stopColor: "#0080FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548934,
    stopColor: "#0098F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74141,
    stopColor: "#009BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928887,
    stopColor: "#009BF8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9501_68811"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12.5 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f550666637158e3aefc4cce6fce39663.svg";
export { ForwardRef as ReactComponent };